import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ImgsViewer from 'react-images-viewer';
import get from 'lodash/get';

const LightBox = ({ isOpened, images, closeLightBox, chosenImage }) => {
  const [image, setImage] = React.useState(0);
  const [imagesToShow, setImages] = React.useState([]);

  useEffect(() => {
    setImage(chosenImage);
  }, [chosenImage]);

  useEffect(() => {
    setImages(
      images.map(photo => ({
        src: get(photo, 'file.urls.large') || get(photo, 'url'),
        caption: get(photo, 'description'),
      })),
    );
  }, [images]);

  const gotoPrev = () => {
    setImage(image - 1);
  };

  const gotoNext = () => {
    setImage(image + 1);
  };

  const gotoImg = index => {
    setImage(index);
  };

  const handleClickImg = () => {
    if (image === images.length - 1) return;
    gotoNext();
  };

  return (
    <ImgsViewer
      backdropCloseable
      imgs={imagesToShow}
      currImg={image}
      isOpen={isOpened}
      showThumbnails
      onClose={closeLightBox}
      onClickImg={handleClickImg}
      onClickNext={gotoNext}
      onClickPrev={gotoPrev}
      onClickThumbnail={gotoImg}
      showCloseBtn={false}
      // theme={{footer: { color: '#000' }}} ?? check it is not applied
    />
  );
};

LightBox.propTypes = {
  images: PropTypes.array,
  isOpened: PropTypes.bool,
  closeLightBox: PropTypes.func,
  chosenImage: PropTypes.number,
};

export default LightBox;
